import {
  DynamicFormConfig,
  FieldTypeEnum, FilterSelectFieldConfig,
  MultipleOptionType,
  TextAreaFieldConfig,
  TextFieldConfig
} from '@mydocma/dynamic-form';
import {MultiOptionConfig} from '@mydocma/dynamic-form/lib/fields/multi-option/multi-option.config';
import {SelectFieldConfig} from '@mydocma/dynamic-form/lib/fields/select/select-field.config';

export const overviewLayoutConfig: MultiOptionConfig = {
  id: 'isOverviewLayout',
  name: 'isOverviewLayout',
  label: {
    text: 'MM.layout.details.useInOverviewProjects'
  },
  source: {
    isOverviewLayout: ''
  },
  optionType: MultipleOptionType.slideToggle,
  type: FieldTypeEnum.multiOption
};


export const nameConfig: TextFieldConfig = {
  id: 'name',
  name: 'name',
  label: {
    text: 'MM.layout.details.name'
  },
  type: FieldTypeEnum.text,
  maxLength: 255,
  required: true
};

export const descriptionConfig: TextAreaFieldConfig = {
  id: 'description',
  name: 'description',
  label: {
    text: 'MM.layout.details.description'
  },
  type: FieldTypeEnum.textarea,
  minRows: 2,
  maxRows: 5,
  maxLength: 4000,
  value: null
};

export const typeConfig: FilterSelectFieldConfig = {
  id: 'type',
  name: 'type',
  label: {
    text: 'MM.layout.details.type'
  },
  type: FieldTypeEnum.filterSelect,
  required: true,
  removeClearButton: true
};

export const visibleForConfig: MultiOptionConfig = {
  id: 'visibleFor',
  name: 'visibleFor',
  label: {
    text: 'MM.layout.details.visibleFor'
  },
  source: {
    sc: { text: 'MM.layout.details.visibleForSC'},
    co: {text: 'MM.layout.details.visibleForCO'},
    ct: { text: 'MM.layout.details.visibleForCT'}
  },
  optionType: MultipleOptionType.slideToggle,
  type: FieldTypeEnum.multiOption,
  hidden: true
};

export const favoritesConfig: MultiOptionConfig = {
  id: 'favoriteFor',
  name: 'favoriteFor',
  label: {
    text: 'MM.layout.details.favoriteFor'
  },
  source: {
    favoriteUser: { text: 'MM.layout.details.favoriteForUser'},
    favoriteAll: { text: 'MM.layout.details.favoriteForAll'}
  },
  optionType: MultipleOptionType.slideToggle,
  type: FieldTypeEnum.multiOption
};

export const favoritesConfigUser: MultiOptionConfig = {
  id: 'favoriteForUser',
  name: 'favoriteForUser',
  label: {
    text: 'MM.layout.details.favoriteFor'
  },
  source: {
    favoriteUser: { text: 'MM.layout.details.favoriteForUser'},
  },
  optionType: MultipleOptionType.slideToggle,
  type: FieldTypeEnum.multiOption
};

export const detailFormConfig: DynamicFormConfig = {
  fields: [
    nameConfig,
    descriptionConfig,
    typeConfig,
    visibleForConfig,
    favoritesConfig,
    favoritesConfigUser,
    overviewLayoutConfig
  ],
  layouts: []
};

export interface OptionViewPointValue {
  ct: any;
  co: any;
  sc: any;
}

export interface OptionFavoriteValue {
  favoriteUser: any;
  favoriteAll?: any;
}


